<script>
import { mapState } from "vuex";

import { validateAndSubmit } from "../../../mixins/validateAndSubmit";
import { validationClass } from "../../../mixins/validationClass";
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";

export default {
  data() {
    return {
      form: {
        definition: null,
        active_demonstration: null,
        how_do_i_demonstrate: null,
        i_want_to_improve: null,
      },
      disableOnSubmit: false,
    };
  },

  props: ["url", "getUrl", "isEdit", "createdGoal", "createGoalUrl"],

  mixins: [validateAndSubmit, validationClass],

  computed: {},

  created() {},

  mounted() {
    this.getItem();
  },

  watch: {},

  methods: {
    getItem() {
      axios
        .get(this.getUrl, {
          params: {},
        })
        .then((response) => {
          this.form = response.data.data;
          this.form.active_demonstration =
            this.form.active_demonstration != null
              ? this.form.active_demonstration
              : 0;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    checkCreateGoalModal() {
      if (this.createdGoal != "1" && this.form.i_want_to_improve != 0) {
        $("#createGoalModal").modal("show");
      } else {
        this.validateAndSubmit("value-edit-form");
      }
    },

    createGoal() {
      axios
        .post(this.createGoalUrl)
        .then((response) => {
          //
        })
        .catch((error) => {
          console.log(error);
        });

      $("#createGoalModal").modal("hide");
      this.validateAndSubmit("value-edit-form");
    },
  },

  components: {
    VueSlider,
  },
};
</script>
